import { IErrorReport } from "@common/models";
import { Action, sendError } from "@service/proxy";
import Translate from "@service/Translate";
import { Component } from "react";
import Alert from "./general/Alert";
import Button from "./general/form/Button";

interface IErrorBoundaryProps { }
interface IErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        const errorReport: IErrorReport = {
            name: error.name,
            message: error.message,
            stack: error.stack,
            cause: error.cause,
            pathname: window.location.pathname
        }
        sendError(Action.POST, { data: errorReport })
    }

    componentDidUpdate() {
        if (this.state.hasError)
            document.documentElement.classList.add("overflow-hidden");
        else
            document.documentElement.classList.remove("overflow-hidden");
    }

    componentWillUnmount() {
        document.documentElement.classList.remove("overflow-hidden");
    }

    render() {
        const { tr } = Translate;
        if (this.state.hasError) {
            return (
                <div className="error-boundary">
                    <div className="error-boundary-root" />
                    <div className="error-boundary-container">
                        <Alert
                            variant="none"
                            type="warning"
                            className="error-boundary-title"
                            seperate
                        >
                            {tr("err_page_not_load")}
                        </Alert>
                        <Button
                            color="primary"
                            variant="contained"
                            height="35px"
                            text={tr('reload')}
                            onClick={() => window.location.reload()}
                        />
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;